import type { Catalog } from "@/lib/i18n/en";

export const fa: Catalog = {
  "app.tagline": "جلسه‌هایی که با یک کلیک شروع می‌شوند.",
  "app.poweredBy": "قدرت‌گرفته از BS Group",
  "app.madeIn": "ساخته‌شده با {heart} در بلژیک",
  "nav.meetings": "جلسه‌ها",
  "nav.rooms": "اتاق‌ها",
  "nav.signIn": "ورود",
  "nav.signOut": "خروج",
  "nav.createAccount": "ساخت حساب",
  "nav.settings": "تنظیمات",
  "nav.docs": "مستندات",
  "nav.privacy": "حریم خصوصی",
  "privacy.title": "{name} Privacy Policy",
  "privacy.description": "How {name} handles personal data, meeting content and recordings.",
  "nav.language": "زبان",
  "nav.theme": "پوسته: {theme}. تغییر به {next}",
  "theme.system": "سیستم",
  "theme.light": "روشن",
  "theme.dark": "تیره",

  "common.cancel": "انصراف",
  "common.confirm": "تأیید",
  "common.save": "ذخیره",
  "common.done": "تمام",
  "common.close": "بستن",
  "common.edit": "ویرایش",
  "common.join": "پیوستن",
  "common.loading": "در حال بارگذاری",
  "common.somethingWentWrong": "مشکلی پیش آمد",
  "common.you": "شما",
  "common.copied": "کپی شد",
  "common.search": "جستجو",
  "common.noMatches": "چیزی پیدا نشد",

  "landing.intro":
    "{name} تماس تصویری است برای کسانی که فقط می‌خواهند حرف بزنند: یک کد بفرستید، صفحه‌تان را به اشتراک بگذارید، روی اسلاید بنویسید و کار را پیش ببرید.",
  "landing.startMeeting": "شروع جلسه",
  "landing.goToMeetings": "رفتن به جلسه‌های شما",
  "landing.codePlaceholder": "abcd-efgh-ijkl",
  "landing.meetingCode": "کد جلسه",
  "landing.feature.guests.title": "مهمان‌ها فقط با یک نام وارد می‌شوند",
  "landing.feature.guests.body":
    "بدون حساب و بدون نصب. هر کسی که لینک را دارد نامی می‌نویسد و وارد می‌شود، با صدا و تصویر کامل.",
  "landing.feature.screen.title": "اشتراک صفحه‌ای که خوانا می‌ماند",
  "landing.feature.screen.body":
    "صفحه با بالاترین کیفیت فرستاده می‌شود و به جای بریده‌شدن، کامل نمایش داده می‌شود تا متن از بین نرود.",
  "landing.feature.board.title": "اسلاید و تخته سفید",
  "landing.feature.board.body":
    "یک PDF یا پاورپوینت بارگذاری کنید تا به اسلایدهایی تبدیل شود که همه می‌توانند در جلسه روی آن بنویسند.",
  "landing.feature.scale.title": "اتاق‌های بزرگ، جلسه‌های طولانی",
  "landing.feature.scale.body":
    "تا 500 نفر در یک جلسه، و هر جلسه می‌تواند تا 20 ساعت ادامه داشته باشد. نه صندلی می‌شمارید و نه بعد از چهل دقیقه قطع می‌شوید.",
  "landing.feature.record.title": "ضبطی که خودش شروع می‌شود",
  "landing.feature.record.body":
    "برای یک اتاق روشنش کنید تا هر جلسه از همان نفر اول خودبه‌خود ضبط شود. کسی لازم نیست یادش بماند، و ضبط بعداً در مرورگر پخش می‌شود.",
  "landing.feature.control.title": "میزبان کنترل را در دست دارد",
  "landing.feature.control.body":
    "اتاق انتظار، نقش برای هر نفر، بی‌صدا کردن، حذف کردن، و پایان‌دادن جلسه برای همه.",
  "landing.badge": "برای پیوستن حساب لازم نیست",
  "landing.joinTitle": "کد دارید؟",
  "landing.joinHint": "لینکی را که برایتان فرستاده‌اند بچسبانید یا کد را بنویسید.",
  "landing.chip.install": "بدون نصب",
  "landing.chip.browser": "در هر مرورگر امروزی کار می‌کند",
  "landing.chip.guests": "مهمان‌ها فقط با یک نام وارد می‌شوند",
  "landing.chip.scale": "تا 500 نفر، تا 20 ساعت",
  "landing.preview.alt":
    "نمای یک جلسهٔ در جریان: چهار نفر در یک شبکه، با دکمه‌های میکروفون، دوربین، هم‌رسانی صفحه و تخته در پایین.",
  "landing.features.title": "هر چه یک جلسه واقعاً لازم دارد",
  "landing.features.body":
    "یک مجموعهٔ بزرگ نیست. همان چند کاری که در یک تماس انجام می‌دهید، درست ساخته شده.",
  "landing.swipe": "برای دیدن بقیه بکشید",
  "landing.how.title": "سه قدم، بدون راه‌اندازی",
  "landing.how.1.title": "جلسه را شروع کنید",
  "landing.how.1.body":
    "وارد شوید و یک دکمه بزنید. اتاق همان لحظه ساخته می‌شود، با کدی که می‌شود بلند خواندش.",
  "landing.how.2.title": "کد را بفرستید",
  "landing.how.2.body":
    "سه دستهٔ چهارحرفی، یا کل لینک. هر کس آن را بگیرد نامش را می‌نویسد و وارد می‌شود.",
  "landing.how.3.title": "حرف بزنید، نشان بدهید، بنویسید",
  "landing.how.3.body":
    "دوربین را روشن کنید، صفحه‌تان را هم‌رسانی کنید، اسلاید بگذارید و همان‌جا با هم رویش بنویسید.",
  "landing.faq.title": "پرسش‌هایی که اول از همه می‌پرسند",
  "landing.faq.account.q": "به حساب کاربری نیاز دارم؟",
  "landing.faq.account.a":
    "فقط برای شروع جلسه. پیوستن هیچ‌وقت حساب نمی‌خواهد: لینک را باز کنید، نامتان را بنویسید و با صدا و تصویر کامل داخل هستید.",
  "landing.faq.limits.q": "چند نفر، و چقدر طولانی؟",
  "landing.faq.limits.a":
    "تا 500 نفر در یک جلسه، و هر جلسه می‌تواند تا 20 ساعت ادامه پیدا کند. چیزی بعد از چهل دقیقه نصفه نمی‌ماند و صندلی‌ای هم نیست که حواستان به شمارشش باشد.",
  "landing.faq.install.q": "چیزی باید نصب کنم؟",
  "landing.faq.install.a":
    "نه. روی موبایل، تبلت و کامپیوتر در مرورگر اجرا می‌شود. اگر آیکون می‌خواهید، می‌شود مثل یک برنامه روی صفحهٔ خانه نصبش کرد.",
  "landing.faq.share.q": "می‌توانم صفحه هم‌رسانی کنم و اسلاید نشان بدهم؟",
  "landing.faq.share.a":
    "بله. صفحهٔ هم‌رسانی‌شده با کیفیت کامل فرستاده می‌شود و برش نمی‌خورد، و فایل PDF یا پاورپوینت به اسلایدهایی تبدیل می‌شود که همه می‌توانند رویشان بنویسند.",
  "landing.faq.record.q": "می‌شود جلسه‌ها خودکار ضبط شوند؟",
  "landing.faq.record.a":
    "بله. میزبان می‌تواند در هر جلسه دکمهٔ ضبط را بزند، یا اتاق را طوری تنظیم کند که هر جلسه از همان لحظهٔ شروع ضبط شود. تا وقتی ضبط در جریان است همه در اتاق از آن باخبرند، و بعد هم در مرورگر پخش می‌شود.",
  "landing.faq.control.q": "چه کسی می‌تواند صدای کسی را ببندد یا بیرونش کند؟",
  "landing.faq.control.a":
    "میزبان، و هر کسی که او میزبان همراه کند. اتاق انتظار، دسترسی جداگانه برای هر نفر، بستن صدا، بیرون کردن، و پایان دادن برای همه وجود دارد.",
  "landing.cta.title": "هر وقت آماده بودید",
  "landing.cta.body": "همین حالا جلسه‌ای شروع کنید، یا با کدی که برایتان فرستاده‌اند وارد شوید.",
  "landing.integrate.title": "می‌خواهید روی آن بسازید؟",
  "landing.integrate.body":
    "{name} یک API مستندشده REST و WebSocket دارد، و کلید سرویس برای ساخت اتاق و جلسه از طرف کاربران خودتان. BS Chat و BS Calendar از همین راه آن را در خودشان جا داده‌اند.",
  "landing.integrate.link": "خواندن راهنمای یکپارچه‌سازی",

  "docs.title": "ای‌پی‌آی {name}",
  "docs.version": "نسخهٔ ۱",
  "docs.errors": "خطاها",
  "docs.event": "رویداد",
  "docs.direction": "جهت",
  "docs.payload": "محموله",
  "docs.inbound": "کلاینت به سرور",
  "docs.outbound": "سرور به کلاینت",
  "docs.body": "بدنه",
  "docs.returns": "برمی‌گرداند",
  "docs.note": "یادداشت",
  "docs.auth.public": "عمومی",
  "docs.auth.user": "توکن کاربر",
  "docs.auth.service": "کلید سرویس",

  "auth.welcomeBack": "خوش آمدید",
  "auth.signInSubtitle": "برای شروع و زمان‌بندی جلسه‌ها وارد شوید.",
  "auth.createTitle": "ساخت حساب کاربری",
  "auth.createSubtitle": "حساب فقط برای میزبانی لازم است. پیوستن هرگز به آن نیاز ندارد.",
  "auth.email": "ایمیل",
  "auth.password": "گذرواژه",
  "auth.currentPassword": "گذرواژه فعلی",
  "auth.newPassword": "گذرواژه جدید",
  "auth.name": "نام",
  "auth.displayName": "نام نمایشی",
  "auth.newHere": "تازه آمده‌اید؟",
  "auth.haveAccount": "از قبل حساب دارید؟",
  "auth.passwordHint": "دست‌کم {count} نویسه",
  "auth.changePassword": "تغییر گذرواژه",
  "auth.passwordChanged": "گذرواژه تغییر کرد. از بقیه دستگاه‌ها خارج شدید.",
  "auth.passwordSection": "تغییر آن، همه دستگاه‌های دیگر را خارج می‌کند.",
  "auth.profileSaved": "نمایه ذخیره شد",
  "auth.nameIsShown": "نام شما همان چیزی است که همه در جلسه می‌بینند.",

  "dash.goodMorning": "صبح بخیر",
  "dash.goodAfternoon": "ظهر بخیر",
  "dash.goodEvening": "عصر بخیر",
  "dash.greeting": "{greeting}، {name}",
  "dash.subtitle": "همین حالا جلسه‌ای شروع کنید، یا برای بعد برنامه بریزید.",
  "dash.startNow": "شروع جلسه",
  "dash.instantTitle": "جلسه فوری",
  "dash.scheduleLater": "زمان‌بندی برای بعد",
  "dash.upcoming": "پیش رو",
  "dash.past": "گذشته",
  "dash.scheduledCount": "{count} جلسه زمان‌بندی‌شده",
  "dash.nothingScheduled": "چیزی زمان‌بندی نشده",
  "dash.nothingScheduledBody":
    "هرچه زمان‌بندی کنید و هر جلسه‌ای که به آن دعوت شوید، اینجا نشان داده می‌شود.",
  "dash.loadFailed": "جلسه‌ها بارگذاری نشدند. اتصال خود را بررسی کنید و دوباره تلاش کنید.",
  "dash.loadingMeetings": "در حال بارگذاری جلسه‌های شما",

  "rooms.title": "اتاق‌های شما",
  "rooms.subtitle": "کد یک اتاق تا وقتی که وجود دارد ثابت می‌ماند.",
  "rooms.loading": "در حال بارگذاری اتاق‌های شما",
  "rooms.new": "اتاق تازه",
  "rooms.created": "اتاق ساخته شد",
  "rooms.none": "هنوز اتاقی ندارید",
  "rooms.noneBody": "یکی بسازید تا کدی داشته باشید که برای جلسه‌های تکرارشونده به کار می‌آید.",
  "rooms.open": "باز کردن",
  "rooms.copyLink": "کپی لینک اتاق",
  "rooms.linkCopied": "لینک اتاق کپی شد",
  "rooms.deleteThis": "حذف «{title}»",
  "rooms.deleteTitle": "«{title}» حذف شود؟",
  "rooms.deleteBody":
    "کد آن دیگر کار نمی‌کند و لینکی که پیش‌تر به اشتراک گذاشته‌اید دیگر جایی را باز نمی‌کند.",
  "rooms.delete": "حذف اتاق",
  "rooms.inCall": "{count} نفر در تماس",
  "rooms.createdWhen": "ساخته‌شده {when}",
  "rooms.capacity": "تا {count} نفر",
  "rooms.noHistory": "هنوز جلسه‌ای در این اتاق برگزار نشده است.",
  "rooms.flag.lobby": "اتاق انتظار",
  "rooms.flag.signedInOnly": "نیازمند ورود",
  "rooms.flag.hostFirst": "اول میزبان",
  "rooms.flag.noRecording": "ضبط خاموش",
  "rooms.flag.noChat": "گفت‌وگو خاموش",
  "rooms.stat.meetings": "جلسه‌ها",
  "rooms.stat.joins": "ورود افراد",
  "rooms.stat.joinsHint": "{people} نفر با حساب کاربری؛ هر بار ورود دوباره جدا شمرده می‌شود.",
  "rooms.stat.peak": "بیشترین هم‌زمان",
  "rooms.stat.totalTime": "زمان کل",
  "rooms.stat.longestHint": "طولانی‌ترین جلسه: {duration}",
  "rooms.stat.messages": "پیام‌های گفت‌وگو",
  "rooms.stat.recordings": "ضبط‌ها",
  "rooms.stat.lastMeeting": "آخرین جلسه",

  "schedule.title": "زمان‌بندی جلسه",
  "schedule.editTitle": "ویرایش جلسه",
  "schedule.titleField": "عنوان",
  "schedule.titlePlaceholder": "هماهنگی هفتگی",
  "schedule.starts": "شروع",
  "schedule.ends": "پایان",
  "schedule.repeat": "تکرار",
  "schedule.repeatNone": "تکرار نمی‌شود",
  "schedule.repeatDaily": "هر روز",
  "schedule.repeatWeekly": "هر هفته",
  "schedule.repeatTwoWeeks": "هر دو هفته یک‌بار",
  "schedule.repeatThreeWeeks": "هر سه هفته یک‌بار",
  "schedule.repeatMonthly": "هر ماه",
  "schedule.repeatTwoMonths": "هر دو ماه یک‌بار",
  "schedule.repeatThreeMonths": "هر سه ماه یک‌بار",
  "schedule.timezoneHint":
    "زمان‌های بالا در این منطقه خوانده می‌شوند. بقیه آن را به وقت خودشان می‌بینند.",
  "schedule.description": "توضیح",
  "schedule.descriptionPlaceholder": "دستور جلسه، لینک‌ها، و هر چیزی که بهتر است از قبل خوانده شود.",
  "schedule.inviteByEmail": "دعوت با ایمیل",
  "schedule.inviteHint":
    "نشانی‌ها را بنویسید یا بچسبانید. فاصله، ویرگول یا نقطه‌ویرگول هر کدام را جدا می‌کند.",
  "schedule.emailsPlaceholder": "sara@example.com، ali@example.com",
  "schedule.submit": "زمان‌بندی",
  "schedule.saved": "جلسه به‌روز شد",
  "schedule.created": "جلسه زمان‌بندی شد",
  "schedule.cancelTitle": "«{title}» لغو شود؟",
  "schedule.cancelBody": "به همه دعوت‌شده‌ها خبر داده می‌شود که جلسه لغو شده است.",
  "schedule.cancelAction": "لغو جلسه",
  "schedule.cancelKeep": "بماند",
  "schedule.cancelled": "جلسه لغو شد",

  "meeting.liveNow": "هم‌اکنون برقرار",
  "meeting.cancelled": "لغو شده",
  "meeting.repeats": "تکرارشونده",
  "meeting.fromService": "از {service}",
  "meeting.accepted": "{accepted} از {total} پذیرفته‌اند",
  "meeting.copyJoinLink": "کپی لینک پیوستن",
  "meeting.invitePeople": "دعوت افراد",
  "meeting.cancelThis": "لغو این جلسه",
  "meeting.linkCopied": "لینک جلسه کپی شد",

  "invite.title": "دعوت افراد",
  "invite.anyoneWithLink": "هر کسی که لینک را دارد",
  "invite.copyLink": "کپی لینک",
  "invite.send": "فرستادن دعوت‌ها",
  "invite.sent": "{count} نفر دعوت شدند",
  "invite.invitedCount": "دعوت‌شده ({count})",
  "invite.copyPersonal": "کپی لینک شخصی برای {email}",
  "invite.remove": "حذف {email}",
  "invite.personalCopied": "لینک شخصی کپی شد",
  "invite.status.pending": "در انتظار",
  "invite.status.accepted": "پذیرفته",
  "invite.status.declined": "رد شده",
  "invite.accept": "پذیرفتن",
  "invite.decline": "رد کردن",
  "invite.invitedYou": "{name} شما را دعوت کرد",
  "invite.joinNow": "همین حالا به جلسه بپیوندید",
  "invite.answered": "شما این دعوت را {status}.",
  "invite.notFound": "دعوت پیدا نشد",
  "invite.notFoundBody":
    "این لینک دعوت دیگر معتبر نیست. از برگزارکننده بخواهید لینک تازه‌ای بفرستد.",
  "invite.opening": "در حال باز کردن دعوت شما",
  "invite.seeYouThere": "می‌بینیمتان",
  "invite.organizerTold": "به برگزارکننده خبر داده شد",

  "prejoin.joinNow": "پیوستن",
  "prejoin.askToJoin": "درخواست پیوستن",
  "prejoin.yourName": "نام شما",
  "prejoin.namePlaceholder": "دوست دارید چه صدایتان کنند؟",
  "prejoin.joiningAs": "با نام {name} وارد می‌شوید",
  "prejoin.hostedBy": "میزبان: {name}",
  "prejoin.alreadyHere": "{count} نفر از قبل اینجا هستند",
  "prejoin.cameraOff": "دوربین شما خاموش است",
  "prejoin.lobbyNote": "این جلسه اتاق انتظار دارد، پس میزبان باید شما را وارد کند.",
  "prejoin.joinMuted": "ورود بی‌صدا",
  "prejoin.joinUnmuted": "ورود با میکروفون روشن",
  "prejoin.joinCameraOff": "ورود با دوربین خاموش",
  "prejoin.joinCameraOn": "ورود با دوربین روشن",

  "call.meeting": "جلسه",
  "call.connecting": "در حال اتصال",
  "call.reconnecting": "اتصال قطع شد. در حال بازگرداندن شما.",
  "call.participantAway": "در حال اتصال دوباره",
  "call.offline": "اینترنت وصل نیست.",
  "call.retryNow": "تلاش دوباره",
  "call.joiningSlow": "بیش از حد معمول طول کشیده",
  "call.joiningSlowBody":
    "جلسه هنوز جواب نداده است. تلاش ادامه دارد و می‌توانید دوباره امتحان کنید.",
  "call.backInTheRoom": "به جلسه برگشتید",
  "call.meetingElapsed": "مدت جلسه",
  "call.joinedElapsed": "از زمان ورود شما",
  "call.joining": "در حال پیوستن به جلسه",
  "call.finding": "در حال پیدا کردن جلسه",
  "call.tapToHear": "برای شنیدن تماس بزنید",
  "call.recording": "در حال ضبط",
  "call.copyLink": "کپی لینک جلسه",
  "call.zoomIn": "بزرگ‌نمایی",
  "call.zoomOut": "کوچک‌نمایی",
  "call.zoomReset": "اندازه اصلی",
  "call.fullScreen": "تمام‌صفحه",
  "call.exitFullScreen": "خروج از تمام‌صفحه",
  "call.settings": "تنظیمات جلسه",
  "call.startRecording": "شروع ضبط",
  "call.stopRecording": "توقف ضبط",
  "call.fullscreen": "تمام‌صفحه",
  "call.exitFullscreen": "خروج از تمام‌صفحه",
  "call.mediaTrouble": "مشکل در اتصال صدا و تصویر",
  "call.noMediaServer": "این سرور سرور رسانه ندارد، پس صدا و تصویر خاموش است",
  "call.noMediaServerBody":
    "گفت‌وگو، تخته سفید و بقیه امکانات جلسه کار می‌کنند. دوربین خودتان فقط برای خودتان نمایش داده می‌شود.",
  "call.mute": "بی‌صدا کردن میکروفون",
  "call.unmute": "روشن کردن میکروفون",
  "call.cameraOn": "روشن کردن دوربین",
  "call.micNotAllowed": "میزبان میکروفون شما را بسته است",
  "call.camNotAllowed": "میزبان دوربین شما را بسته است",
  "call.cameraOff": "خاموش کردن دوربین",
  "call.share": "اشتراک صفحه",
  "call.youAreSharing": "این صفحه را شما به اشتراک گذاشته‌اید",
  "call.stopShare": "توقف اشتراک صفحه",
  "call.raiseHand": "بالا بردن دست",
  "call.lowerHand": "پایین آوردن دست",
  "call.leave": "خروج از جلسه",
  "call.leaveOrEnd": "بیرون بروید یا جلسه را تمام کنید؟",
  "call.leaveOrEndBody":
    "{count} نفر دیگر هنوز اینجا هستند. اگر بیرون بروید جلسه بدون شما ادامه پیدا می‌کند. اگر تمامش کنید همه از جلسه بیرون می‌آیند.",
  "call.justLeave": "فقط بیرون می‌روم",
  "call.endForEveryone": "پایان برای همه",
  "call.people": "افراد",
  "call.chat": "گفت‌وگو",
  "call.present": "تخته سفید",
  "call.settingsTitle": "تنظیمات",
  "call.audioVideo": "صدا و تصویر",
  "call.switchCamera": "تعویض به {camera}",
  "call.switchOutput": "پخش صدا از {device}",
  "call.moreOptions": "گزینه‌های بیشتر",
  "call.closePanel": "بستن پنل",
  "call.waitingForOthers": "در انتظار پیوستن دیگران.",
  "call.pin": "سنجاق کردن به نمای اصلی",
  "call.unpin": "برداشتن سنجاق",
  "call.host": "میزبان",
  "call.waitingToBeLetIn": "در انتظار ورود",
  "call.waitingBody": "میزبان باید شما را وارد کند. این صفحه به‌محض آن خودش به‌روز می‌شود.",
  "call.ended": "جلسه تمام شد",
  "call.removedByHost": "میزبان شما را از جلسه حذف کرد",
  "call.notIn": "شما در جلسه نیستید",
  "call.youLeft": "شما از جلسه خارج شدید.",
  "call.rejoin": "پیوستن دوباره",
  "call.backToMeetings": "بازگشت به جلسه‌ها",
  "call.backToWhereYouCameFrom": "بازگشت به همان‌جا که آمدید",
  "call.notFound": "این جلسه پیدا نشد",
  "call.notFoundBody": "کد را بررسی کنید، یا از کسی که دعوتتان کرده لینک تازه بخواهید.",
  "call.speakingWhileMuted": "دارید حرف می‌زنید، ولی میکروفون شما بسته است",
  "call.mutedByHost": "میزبان شما را بی‌صدا کرد",
  "call.someoneCouldNotBeHeard": "صدا یا تصویر بعضی از افراد دریافت نشد",

  "people.inMeeting": "در جلسه ({count})",
  "people.waiting": "در انتظار ورود ({count})",
  "people.admit": "پذیرفتن {name}",
  "people.deny": "رد کردن {name}",
  "people.muteEveryone": "بی‌صدا کردن همه",
  "people.mutedEveryoneResult": "{count} نفر بی‌صدا شدند",
  "people.mutedNobody": "همه از قبل بی‌صدا بودند",
  "people.options": "گزینه‌های {name}",
  "people.mute": "بی‌صدا کردن",
  "people.makeRole": "تبدیل به {role}",
  "people.remove": "حذف از جلسه",
  "people.lobbyOn": "اتاق انتظار روشن است",
  "people.giveControl": "واگذاری ارائه به او",
  "people.presenting": "در حال ارائه",
  "people.allowedTo": "اجازه دارد",
  "grant.mic": "استفاده از میکروفون",
  "grant.cam": "استفاده از دوربین",
  "grant.share": "اشتراک صفحه",
  "grant.draw": "نوشتن روی اسلاید",
  "grant.upload": "گذاشتن اسلاید تازه",
  "board.takeControl": "گرفتن ارائه",
  "board.someoneElsePresenting": "{name} در حال ارائه است",
  "board.youArePresenting": "شما در حال ارائه هستید",
  "role.host": "میزبان",
  "role.cohost": "هم‌میزبان",
  "role.presenter": "ارائه‌دهنده",
  "role.guest": "مهمان",

  "chat.placeholder": "پیامی بفرستید",
  "chat.send": "فرستادن",
  "chat.message": "پیام",
  "chat.empty": "پیام‌های اینجا را همه در جلسه می‌بینند و پس از جلسه نگه داشته نمی‌شوند.",
  "chat.whisperFrom": "{name} درِگوشی گفت: {body}",
  "chat.whisperTo": "پیام خصوصی به {name}",
  "chat.privateTo": "خصوصی به {name}",
  "chat.privateFrom": "خصوصی",
  "chat.toEveryone": "همه",
  "chat.recipient": "فرستادن به",
  "chat.whisperPlaceholder": "پیام خصوصی به {name}",
  "chat.whisperNote": "فقط {name} این را می‌بیند.",

  "board.present": "ارائه",

  "board.tools": "ابزارهای رسم",
  "board.presentBody":
    "همه در جلسه یک صفحه را می‌بینند، و هر کسی که اجازه ارائه دارد می‌تواند روی آن بنویسد.",
  "board.uploadDocument": "بارگذاری PDF یا پاورپوینت",
  "board.uploadImages": "بارگذاری تصویر به‌عنوان اسلاید",
  "board.blank": "تخته سفید خالی",
  "board.notAllowed": "میزبان به شما اجازهٔ گذاشتن اسلاید در این جلسه را نداده است.",
  "board.uploading": "بارگذاری {percent}٪",
  "board.checking": "در حال بررسی اینکه این فایل از قبل اینجا هست یا نه",
  "board.alreadyHere": "{title} از قبل در این جلسه هست، پس بدون بارگذاری دوباره باز می‌شود",
  "board.noConversion":
    "تبدیل سند روی این سرور تنظیم نشده، پس بارگذاری PDF و پاورپوینت در دسترس نیست. تصویر و تخته سفید خالی همچنان کار می‌کنند.",
  "board.limits": "تا {size} و {pages} صفحه برای هر سند.",
  "board.presenting": "در حال ارائه {title}، صفحه {page} از {total}.",
  "board.tooLarge": "«{file}» با حجم {size} از محدوده {limit} بیشتر است",
  "board.fileEmpty": "«{file}» خالی است و چیزی برای نمایش ندارد",
  "board.fileUnsupported": "«{file}» از نوع‌هایی نیست که بتوان ارائه کرد",
  "board.tooManyPages": "{count} تصویر انتخاب شده است و هر مجموعه حداکثر {limit} صفحه دارد",
  "board.preparing": "در حال آماده‌سازی اسلایدها",
  "board.preparingProgress": "در حال آماده‌سازی اسلایدها ({page} از {total})",
  "board.previousPage": "صفحه پیش",
  "board.nextPage": "صفحه بعد",
  "board.zoomIn": "بزرگ‌نمایی",
  "board.zoomOut": "کوچک‌نمایی",
  "board.zoomPercent": "٪{percent}",
  "board.fitScreen": "نمایش کل صفحه",
  "board.fullWidth": "هم‌عرض صفحه",
  "board.pan": "جابه‌جایی صفحه",
  "board.stopPresenting": "پایان ارائه",
  "board.undo": "برگرداندن آخرین خط",
  "board.clearPage": "پاک کردن این صفحه برای همه",
  "board.textPrompt": "متنی که اضافه می‌شود",
  "board.textPromptBody": "همان‌جا که لمس کردید نوشته می‌شود و همه در جلسه آن را می‌بینند.",
  "board.textPlaceholder": "متن را بنویسید",
  "board.addText": "افزودن متن",
  "board.colour": "رنگ {colour}",
  "board.thickness": "ضخامت {size}",
  "board.palette": "رنگ‌ها",
  "board.moreColours": "رنگ‌های بیشتر، {colour} انتخاب شده است",
  "board.customColour": "دلخواه",
  "colour.red": "قرمز",
  "colour.orange": "نارنجی",
  "colour.amber": "کهربایی",
  "colour.yellow": "زرد",
  "colour.lime": "لیمویی",
  "colour.green": "سبز",
  "colour.emerald": "زمردی",
  "colour.teal": "سبزآبی",
  "colour.cyan": "فیروزه‌ای",
  "colour.sky": "آبی آسمانی",
  "colour.blue": "آبی",
  "colour.indigo": "نیلی",
  "colour.violet": "بنفش",
  "colour.purple": "ارغوانی",
  "colour.fuchsia": "سرخابی",
  "colour.pink": "صورتی",
  "colour.rose": "رز",
  "colour.brown": "قهوه‌ای",
  "colour.slate": "خاکستری",
  "colour.ink": "مشکی",
  "colour.white": "سفید",
  "tool.pen": "قلم",
  "tool.highlighter": "هایلایت",
  "tool.line": "خط",
  "tool.arrow": "پیکان",
  "tool.rect": "مستطیل",
  "tool.ellipse": "بیضی",
  "tool.text": "متن",
  "tool.eraser": "پاک‌کن",

  "device.microphone": "میکروفون",
  "device.camera": "دوربین",
  "device.speakers": "بلندگو",
  "effect.background": "پس‌زمینه",
  "effect.none": "خاموش",
  "effect.blur": "محو",
  "effect.blurStrong": "محو شدید",
  "effect.hint":
    "همه در جلسه همین تصویر را می‌بینند، نه فقط شما. پردازش روی همین دستگاه انجام می‌شود و چیزی از آن بیرون نمی‌رود.",
  "effect.unsupported": "این مرورگر افکت پس‌زمینه را اجرا نمی‌کند.",
  "device.noOutputPicker":
    "این مرورگر اجازه نمی‌دهد صفحه، دستگاه خروجی را انتخاب کند. آن را در تنظیمات سیستم عوض کنید.",
  "device.namesAfterPermission":
    "نام دستگاه‌ها پس از اجازه دادن به دوربین یا میکروفون نمایش داده می‌شود.",

  "mic.title": "میکروفون",
  "mic.settingsBody":
    "این‌که دیگران صدای شما را چطور می‌شنوند. برای هر جلسه‌ای که در این مرورگر به آن می‌پیوندید اعمال می‌شود.",
  "mic.level": "سطح ورودی",
  "mic.levelBody":
    "چیزی بگویید. نوار همان چیزی را دنبال می‌کند که میکروفون می‌گیرد، پیش از آن‌که چیزی فرستاده شود.",
  "mic.levelOff": "میکروفون را روشن کنید تا ببینید چه می‌گیرد.",
  "mic.noiseSuppression": "حذف نویز",
  "mic.noiseSuppressionBody":
    "صدای فن، تایپ و همهمهٔ اتاق را برمی‌دارد. تا وقتی دلیلی ندارید روشن بماند.",
  "mic.echoCancellation": "حذف اکو",
  "mic.echoCancellationBody":
    "جلوی برگشتن صدای بلندگوی شما به جلسه را می‌گیرد. فقط وقتی هدفون روی گوشتان است خاموشش کنید.",
  "mic.autoGain": "تنظیم خودکار بلندی",
  "mic.autoGainBody":
    "می‌گذارد مرورگر بلندی صدای شما را یکدست کند، وقتی به میکروفون نزدیک و از آن دور می‌شوید.",
  "mic.noBrowserProcessing": "این مرورگر اجازه نمی‌دهد صفحه، پردازش میکروفون را تغییر دهد.",
  "mic.quality": "کیفیت صدا",
  "mic.qualitySpeech": "گفتار",
  "mic.qualitySpeechBody":
    "هر بار یک صدا، و در سکوت میان جمله‌ها هیچ چیز فرستاده نمی‌شود. پاسخ درست برای یک جلسه.",
  "mic.qualityClear": "گفتار شفاف",
  "mic.qualityClearBody": "دو برابر نرخ بیت، برای صدایی روی اتصالی که از پس آن برمی‌آید.",
  "mic.qualityMusic": "موسیقی",
  "mic.qualityMusicBody":
    "هر دو کانال، چهار برابر نرخ بیت، و هیچ چیز میان عبارت‌ها بریده نمی‌شود. برای ساز یا پخش صدا، نه برای حرف زدن.",
  "mic.volume": "بلندی میکروفون",
  "mic.clarity": "تیزی صدا",
  "mic.clarityBody":
    "تیزی آن بخشی از صدا را که همخوان‌ها را می‌رساند بالا می‌آورد و غرش زیر آن را کم می‌کند؛ همین است که دنبال کردن یک گویندهٔ آرام را ساده‌تر می‌کند.",
  "mic.gate": "دروازهٔ نویز",
  "mic.gateOff": "خاموش",
  "mic.gateBody":
    "دروازه زیر سطحی که روی نوار علامت خورده میکروفون را کامل می‌بندد، پس اتاقی که کسی در آن حرف نمی‌زند هیچ چیز نمی‌فرستد. آن‌قدر بالا ببرید که نشانه بالای صدای اتاق و پایین‌تر از صدای خودتان بایستد.",
  "mic.percent": "{value}٪",
  "mic.volumeMin": "کم‌ترین",
  "mic.volumeMax": "بیشترین",
  "mic.clarityMin": "خاموش",
  "mic.clarityMax": "بیشترین",
  "mic.gateMax": "سخت‌گیرترین",
  "mic.reset": "بازگرداندن به پیش‌فرض",

  "voice.title": "صدا",
  "voice.none": "عادی",
  "voice.woman": "زنانه",
  "voice.man": "مردانه",
  "voice.chipmunk": "سنجابی",
  "voice.giant": "غول",
  "voice.robot": "ربات",
  "voice.alien": "فضایی",
  "voice.custom": "دلخواه",
  "voice.hint":
    "همه در جلسه همان صدایی را می‌شنوند که انتخاب می‌کنید، نه صدای خودتان. این کار روی همین دستگاه انجام می‌شود و چیز بیشتری فرستاده نمی‌شود.",
  "voice.listen": "صدای خودم را بشنوم",
  "voice.stopListening": "توقف",
  "voice.listenBody": "اول هدفون بگذارید، وگرنه اتاق صدای خودش را می‌شنود.",
  "voice.unsupported": "این مرورگر نمی‌تواند صدا را تغییر دهد.",
  "voice.pitch": "زیر و بمی",
  "voice.pitchMin": "بم‌تر",
  "voice.pitchMax": "زیرتر",
  "voice.semitones": "{value} نیم‌پرده",
  "voice.noShift": "بدون تغییر",
  "voice.formant": "اندازه صدا",
  "voice.formantMin": "بزرگ‌تر",
  "voice.formantMax": "کوچک‌تر",
  "voice.customBody":
    "زیر و بمی همان نتی است که با آن حرف می‌زنید. اندازه صدا یعنی گلویی که پشت آن است چقدر بزرگ به گوش می‌آید، و جابه‌جا کردن هر دو با هم است که یک صدای دیگر را باورپذیر می‌کند، نه فقط زیر یا بم.",

  "sound.title": "صداها",
  "sound.cues": "افکت‌های صوتی",
  "sound.cuesBody":
    "یک نوای کوتاه وقتی کسی وارد می‌شود، بیرون می‌رود، دست بلند می‌کند یا پیام می‌فرستد.",
  "sound.speech": "اعلام گفتاری",
  "sound.speechBody": "آنچه رخ داده را با صدای بلند و به زبان همین صفحه می‌گوید.",
  "sound.settingsBody": "برای همهٔ جلسه‌هایی که در این مرورگر می‌پیوندید اعمال می‌شود.",
  "sound.volume": "بلندی صدا",
  "sound.test": "آزمایش",
  "sound.percent": "{value}٪",
  "sound.volumeMin": "بی‌صدا",
  "sound.volumeMax": "بلندترین",
  "sound.noVoice": "این مرورگر صدای {language} ندارد، پس چیزی با صدای بلند گفته نمی‌شود.",
  "sound.joined": "{name} وارد شد",
  "sound.joinedMany": "{count} نفر وارد شدند",
  "sound.left": "{name} بیرون رفت",
  "sound.leftMany": "{count} نفر بیرون رفتند",
  "sound.knocking": "{name} منتظر اجازه ورود است",
  "sound.knockingMany": "{count} نفر منتظر اجازه ورود هستند",
  "sound.admitted": "وارد جلسه شدید",
  "sound.chatMessage": "پیام از {name}",
  "sound.chatMessageMany": "{count} پیام تازه",
  "sound.handRaised": "{name} دست بلند کرد",
  "sound.recordingOn": "ضبط شروع شد",
  "sound.recordingOff": "ضبط متوقف شد",
  "sound.speakingWhileMuted": "میکروفون شما بسته است",
  "sound.grantedMic": "می‌توانید از میکروفون خود استفاده کنید",
  "sound.revokedMic": "دیگر نمی‌توانید از میکروفون خود استفاده کنید",
  "sound.grantedCam": "می‌توانید از دوربین خود استفاده کنید",
  "sound.revokedCam": "دیگر نمی‌توانید از دوربین خود استفاده کنید",
  "sound.grantedShare": "می‌توانید صفحه‌تان را هم‌رسانی کنید",
  "sound.revokedShare": "دیگر نمی‌توانید صفحه‌تان را هم‌رسانی کنید",
  "sound.grantedDraw": "می‌توانید روی اسلایدها بنویسید",
  "sound.revokedDraw": "دیگر نمی‌توانید روی اسلایدها بنویسید",
  "sound.grantedUpload": "می‌توانید اسلاید تازه بگذارید",
  "sound.revokedUpload": "دیگر نمی‌توانید اسلاید تازه بگذارید",
  "sound.permissionsChanged": "دسترسی‌های شما تغییر کرد",
  "sound.nowHost": "اکنون میزبان هستید",
  "sound.nowCohost": "اکنون میزبان همراه هستید",
  "sound.nowPresenter": "اکنون می‌توانید ارائه بدهید",
  "sound.nowGuest": "اکنون مهمان هستید",
  "sound.mutedByHost": "میزبان صدای شما را بست",
  "sound.screenOn": "{name} صفحه‌اش را هم‌رسانی می‌کند",
  "sound.screenOff": "{name} هم‌رسانی را متوقف کرد",
  "sound.presenting": "ارائهٔ {title} آغاز شد",
  "sound.reconnecting": "ارتباط قطع شد. در حال اتصال دوباره",
  "sound.reconnected": "دوباره در جلسه هستید",
  "sound.ended": "جلسه به پایان رسید",

  "recordings.show": "ضبط‌ها",
  "recordings.showCount": "ضبط‌ها ({count})",
  "recordings.startedBy": "آغاز به دست {name}",
  "recordings.none": "این اتاق هنوز ضبطی ندارد.",
  "recordings.inProgress": "در حال ضبط",
  "recordings.copyLink": "رونوشت لینک",
  "recordings.linkCopied": "لینک رونوشت شد. هر کسی آن را داشته باشد می‌تواند ضبط را ببیند.",
  "recordings.watch": "تماشا",
  "playback.loading": "در حال باز کردن ضبط",
  "playback.missing": "این ضبط اینجا نیست",
  "playback.missingBody":
    "ممکن است لینک اشتباه باشد یا ضبط حذف شده باشد. ضبط‌ها فقط از راه همان لینکی که با آن به اشتراک گذاشته شده‌اند در دسترس‌اند.",
  "playback.unavailable": "ضبط بارگذاری نشد",
  "playback.unavailableBody": "در رسیدن به سرور مشکلی پیش آمد. کمی بعد دوباره تلاش کنید.",
  "playback.recordedBy": "ضبط‌شده توسط {name}",
  "playback.noBoard": "در این لحظه چیزی ارائه نمی‌شد",
  "playback.chat": "گفت‌وگو",
  "playback.noChat": "تا این لحظه چیزی گفته نشده است.",
  "playback.play": "پخش",
  "playback.pause": "توقف",
  "playback.seek": "جای‌گاه در ضبط",
  "playback.micOn": "میکروفون روشن",
  "playback.micOff": "میکروفون خاموش",
  "playback.camOn": "دوربین روشن",
  "playback.camOff": "دوربین خاموش",

  "settings.lobby": "اتاق انتظار",
  "settings.lobbyBody": "افراد منتظر می‌مانند تا میزبان واردشان کند.",
  "settings.allowGuests": "اجازه به مهمان‌ها",
  "settings.allowGuestsBody": "هر کسی که لینک را دارد با نوشتن یک نام وارد می‌شود.",
  "settings.muteOnEntry": "بی‌صدا هنگام ورود",
  "settings.muteOnEntryBody": "همه بی‌صدا وارد می‌شوند.",
  "settings.shareLink": "نمایش پیوند پیوستن",
  "settings.shareLinkBody": "کد اتاق و دکمه کپی در سربرگ جلسه.",
  "settings.allowScreenShare": "اجازه اشتراک صفحه",
  "settings.allowBoard": "اجازه ارائه",
  "settings.allowBoardBody": "اسلاید و تخته سفید.",
  "settings.allowChat": "اجازه گفت‌وگو",
  "settings.allowWhisper": "اجازه پیام خصوصی",
  "settings.allowWhisperBody":
    "افراد می‌توانند به‌جای همه، تنها به یک نفر در جلسه پیام بدهند. برای جلسه‌ای که هر چه گفته می‌شود باید پیش همه گفته شود، این را خاموش کنید.",
  "settings.allowRecording": "اجازه‌ی ضبط",
  "settings.allowRecordingBody":
    "میزبان می‌تواند جلسه را ضبط کند. تا وقتی ضبط در جریان است، به همه‌ی افراد اتاق گفته می‌شود.",
  "settings.autoRecord": "ضبط خودکار هر جلسه",
  "settings.autoRecordBody":
    "ضبط همراه با شروع جلسه خودش آغاز می‌شود تا کسی لازم نباشد یادش بماند. مدیر جلسه هر وقت بخواهد متوقفش می‌کند.",
  "settings.tabDevices": "صدا و تصویر",
  "settings.tabMeeting": "جلسه",
  "settings.tabGuests": "مهمان‌ها",
  "settings.pageSubtitle": "نمایه، گذرواژه، و اینکه صدای جلسه‌ها پیش از پیوستن چطور باشد.",
  "settings.memberSince": "عضو از {date}",
  "settings.groupAccount": "حساب کاربری",
  "settings.groupAudio": "صدا",
  "settings.sections": "بخش‌های تنظیمات",
  "settings.groupEntry": "ورود به جلسه",
  "settings.groupDuring": "در طول جلسه",
  "settings.groupRecording": "ضبط",
  "settings.guestDefaults": "مهمان‌ها چه کاری می‌توانند بکنند",
  "settings.guestDefaultsBody":
    "برای کسانی که به‌عنوان مهمان وارد می‌شوند. هر کسی را که ارتقا بدهید یا جداگانه اجازه بدهید، همان اجازه را نگه می‌دارد.",
  "settings.hostOnly": "فقط میزبان می‌تواند این‌ها را تغییر دهد.",
  "settings.endForEveryone": "پایان جلسه برای همه",

  "settings.stage": "چیدمان",
  "settings.stageBody": "این جلسه برای همهٔ کسانی که در آن هستند چگونه چیده شود.",
  "settings.autoJoin": "مستقیم وارد شو",
  "settings.autoJoinBody":
    "بدون صفحهٔ دوربین و میکروفون. برای جلسه‌هایی که کسی از جای دیگری به آن‌ها فرستاده می‌شود و پیش‌تر پیوستن را انتخاب کرده است.",
  "settings.cameraOffOnEntry": "دوربین خاموش هنگام ورود",
  "settings.cameraOffOnEntryBody": "همه با دوربین خاموش وارد می‌شوند.",

  "stage.standard": "جلسه",
  "stage.standardBody": "همه در یک شبکه، با نوار ابزار کامل و پنل‌ها در کنارش.",
  "stage.telegram": "گفت‌وگو",
  "stage.telegramBody": "دوربین‌ها در نواری بالا، بقیه در فهرستی زیر آن، و یک میکروفون بزرگ.",

  "talk.participants": "{count} شرکت‌کننده",
  "talk.listening": "در حال شنیدن",
  "talk.speaking": "در حال صحبت",
  "talk.muted": "بی‌صدا",
  "talk.wantsToSpeak": "می‌خواهد صحبت کند",
  "talk.sharing": "در حال هم‌رسانی صفحه",
  "talk.youAreLive": "صدایتان پخش می‌شود",
  "talk.unmute": "باصدا کردن",
  "talk.video": "دوربین",
  "talk.leave": "خروج",
  "talk.putAway": "کنار گذاشتن تماس",
  "talk.askToSpeak": "درخواست صحبت",
  "talk.cancelAsk": "بی‌خیال",
  "talk.letThemSpeak": "به {name} اجازهٔ صحبت بده",
  "talk.muteThem": "{name} را بی‌صدا کن",
  "talk.noCameras": "هیچ‌کس دوربینش را روشن نکرده است.",

  "lobby.knocking": "از {name} خواسته شد شما را راه بدهد.",
  "lobby.stillWaiting": "هنوز منتظرید. شاید هنوز آن را ندیده باشد.",
  "lobby.notYetLive": "هنوز کسی شما را نمی‌شنود و نمی‌بیند",

  "error.unauthorized": "لطفاً دوباره وارد شوید.",
  "error.forbidden": "اجازه این کار را ندارید.",
  "error.not_found": "پیدا نشد.",
  "error.bad_credentials": "ایمیل و گذرواژه با هم نمی‌خوانند.",
  "error.email_taken": "این نشانی از قبل حساب دارد.",
  "error.registration_closed": "این سرور حساب تازه نمی‌پذیرد.",
  "error.session_revoked":
    "چون از این ورود دو بار استفاده شد، شما را خارج کردیم. دوباره وارد شوید.",
  "error.session_expired": "نشست شما تمام شد. لطفاً دوباره وارد شوید.",
  "error.crashTitle": "مشکلی پیش آمد",
  "error.crashBody":
    "این صفحه از کار افتاد. معمولاً بارگذاری دوباره مشکل را حل می‌کند و می‌توانید با همان پیوند به جلسه برگردید.",
  "error.crashReload": "بارگذاری دوباره",
  "error.room_full": "این جلسه پر است.",
  "error.guests_not_allowed": "این جلسه فقط برای کاربران واردشده باز است.",
  "error.host_absent": "جلسه هنوز شروع نشده است.",
  "error.meeting_cancelled": "این جلسه لغو شده است.",
  "error.bad_passcode": "این رمز درست نیست.",
  "error.bad_code": "این کد جلسه معتبر نیست.",
  "error.already_sharing": "کس دیگری در حال اشتراک صفحه است.",
  "error.no_media_server": "این سرور سرور رسانه ندارد، پس صدا و تصویر در دسترس نیست.",
  "error.media_denied":
    "مرورگر اجازهٔ دسترسی به دوربین یا میکروفون را نداد. از نوار آدرس اجازه بدهید و دوباره تلاش کنید.",
  "error.media_missing": "دوربین یا میکروفونی از این نوع پیدا نشد.",
  "error.media_busy": "برنامهٔ دیگری در حال استفاده از این دستگاه است.",
  "error.media_unsupported": "این مرورگر از پس این کار برنمی‌آید.",
  "error.media_unknown": "این دستگاه باز نشد.",
  "error.recording_disabled": "این سرور جلسه‌ها را ضبط نمی‌کند.",
  "error.already_joined": "شما همین حالا در این جلسه هستید.",
  "error.no_board": "چیزی ارائه نمی‌شود.",
  "error.not_presenting": "کس دیگری در حال ارائه است.",
  "error.record_failed": "ضبط شروع نشد.",
  "error.too_long": "این برای فرستادن بزرگ‌تر از حد است.",
  "error.media_error": "سرور رسانه در دسترس نبود.",
  "error.conversion_unavailable": "این سرور نمی‌تواند سند تبدیل کند. به‌جای آن تصویر بارگذاری کنید.",
  "error.too_large": "این فایل از حد مجاز این سرور بزرگ‌تر است.",
  "error.unsupported_type": "این نوع فایل قابل ارائه نیست.",
  "error.too_many_rooms": "به سقف تعداد اتاق‌ها رسیده‌اید. اول یکی را حذف کنید.",
  "error.network_error": "سرور در دسترس نبود.",
  "error.unavailable": "سرور موقتاً در دسترس نیست.",
  "error.timeout": "سرور به‌موقع پاسخ نداد.",
  "error.disconnected": "اتصال به جلسه قطع شد.",

  "notFound.title": "پیدا نشد",
  "notFound.body": "صفحه‌ای که دنبالش بودید وجود ندارد.",
  "notFound.home": "رفتن به صفحه اصلی",

  "schedule.timezone": "منطقهٔ زمانی",
  "schedule.endsBeforeStart": "پایان باید بعد از شروع باشد.",
  "calendar.previousMonth": "ماه پیش",
  "calendar.nextMonth": "ماه بعد",
  "calendar.today": "امروز",
  "emails.remove": "حذف {email}",
  "emails.notAddresses": "نشانی ایمیل نیست: {list}",
  "meeting.inZone": "{time} به وقت {zone}",
};
